// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EiBk_","icon":"styles_icon__15KSc"};